import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { wdtcContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const AllowanceWbtc1 = () => {

  // const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.instituson;
  const tokenAddress1 = Environment.wbtc
  const contract = wdtcContract(tokenAddress1, web3);


  const allowanceWbtc1 = useCallback(
    async () => {
        // console.log(tokenAddress,account,'noor');
      try {
        const buy = await contract.methods.allowance(account,tokenAddress).call()
        // console.log('sdsdss' ,  buy)
        return buy/10**8;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return { allowanceWbtc1: allowanceWbtc1 };
};
export default AllowanceWbtc1;